import { useCallback } from "react"
import { useComputed } from "@preact/signals-react"

import { formData } from "../@signals"


export default function useAdminBrandForm(field) {
	const value = useComputed(() => formData.value?.[field] || '')

	const handleChange = useCallback(newValue => {
		formData.value = { ...formData.value,  [field]: newValue}
	}, [field])

	return {
		value: value.value,
		
		handleChange
	}
}